import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
// import AppHeader from "./AppHeader";
const Layout = ({ component }) => {
  const ComponentToRender = component;
  return (
    <>
      <div className="dashboard-main wrap">
        <Navbar />
        <div className="row">
          <div className="col-lg-2 col-md-4 col-12 p-0">
            <Sidebar />
          </div>
          <div className="col-lg-10 col-md-8 col-12 p-0">
            <ComponentToRender />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
